import { useThemeUI } from 'theme-ui';
import { path } from '@uswitch/ev-utils/obj';
import { Container } from '@uswitch/ev-core/react';
import HeroWithBackgroundImg from '../../compounds/hero-with-background-img';
import Breadcrumb from '../../compounds/breadcrumb';
import Grid from '../../compounds/grid/grid-from-json.connected';
import { useEntity } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var WrappedHeroWithBackgroundImg = function WrappedHeroWithBackgroundImg(_ref) {
  var _imageEntity$file;

  var breadcrumbs = _ref.breadcrumbs,
      children = _ref.children,
      content = _ref.content,
      image = _ref.image,
      layout = _ref.layout;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var imageEntity = useEntity(image);

  var _path = path(['modules', 'hero-with-background-image', 'layout'], theme, {}),
      _path$contentCols = _path.contentCols,
      contentCols = _path$contentCols === void 0 ? 12 : _path$contentCols,
      _path$contentSpan = _path.contentSpan,
      contentSpan = _path$contentSpan === void 0 ? 12 : _path$contentSpan;

  var breadcrumbComponent = breadcrumbs ? _jsx(Breadcrumb, {
    entity: breadcrumbs,
    variant: "light"
  }) : null;
  var containerStyles = {
    '> *': {
      height: '100%',
      alignContent: breadcrumbs ? 'space-between' : 'flex-end',
      variant: 'modules.hero-with-background-image.container-child'
    },
    variant: 'modules.hero-with-background-image.container'
  };
  var imageUrl = imageEntity === null || imageEntity === void 0 ? void 0 : (_imageEntity$file = imageEntity.file) === null || _imageEntity$file === void 0 ? void 0 : _imageEntity$file.url;
  return _jsx(HeroWithBackgroundImg, {
    sx: {
      variant: imageUrl === undefined && 'modules.hero-with-background-image.variants.no-image'
    },
    imageUrl: imageUrl,
    children: _jsx(Container, {
      cols: contentCols,
      span: contentSpan,
      sx: containerStyles,
      children: _jsx(Grid, {
        prependContent: breadcrumbComponent,
        content: content,
        layout: layout
      })
    })
  });
};

export default WrappedHeroWithBackgroundImg;
//# sourceMappingURL=hero-with-background-img.connected.js.map